module.exports = __webpack_public_path__ + "img/icon-recurent-item.73f890e0.svg";